import React from 'react'
import CareerSection from '../../component/Careers/CareerHeader/CareerSection'
import CareerForm from '../../component/Careers/CareerForm/CareerForm'
import BenefitsSection from '../../component/Careers/BenefitsSection/BenefitsSection'
import CareerHeader from '../../component/Careers/CareerHeader/CareerHeader'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import FloatingContactUs from '../../component/floting_contact/FloatingContactUs'
import { Helmet } from "react-helmet-async";



const CareerPage = () => {
  return (
   <> 
        {/* ✅ Meta Tags for SEO */}
      
      <Helmet>
  <title>Careers at Nextech PLM</title>
  <meta
    name="description"
    content="Join Nextech PLM in Pune, India. Explore exciting career opportunities and be part of a leading PLM consulting and services company."
  />
  <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
</Helmet>

        <ToastContainer />
        <FloatingContactUs />
        <CareerHeader />
        <CareerSection />
        <BenefitsSection />
        <CareerForm />
    </>
  )
}

export default CareerPage;